export class LoginModel {
    public Email: string;
    public Password: string;
    public rememberme:string;
}
